import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("circle", {
        id: "Ellipse",
        cx: "11.5",
        cy: "12",
        r: "11.5",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        id: "Vector",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.1027 15.7658C12.1027 15.8909 12.1537 16.0108 12.2446 16.0992C12.3355 16.1877 12.4588 16.2374 12.5873 16.2374H16.4644C16.5929 16.2374 16.7162 16.1877 16.8071 16.0992C16.898 16.0108 16.949 15.8909 16.949 15.7658V11.9934C16.949 11.8683 16.898 11.7484 16.8071 11.66C16.7162 11.5715 16.5929 11.5219 16.4644 11.5219C16.3358 11.5219 16.2126 11.5715 16.1217 11.66C16.0308 11.7484 15.9797 11.8683 15.9797 11.9934V14.4455L12.4778 10.2798C12.4349 10.2289 12.3815 10.1873 12.3211 10.1576C12.2607 10.128 12.1946 10.111 12.1271 10.1077C12.0595 10.1044 11.992 10.1149 11.9289 10.1385C11.8657 10.1622 11.8084 10.1984 11.7605 10.2449L9.25299 12.6847L5.70933 7.94373C5.63181 7.84782 5.5191 7.78488 5.39489 7.76813C5.27067 7.75139 5.14462 7.78215 5.04322 7.85395C4.94183 7.92574 4.87298 8.03298 4.85115 8.15314C4.82932 8.27329 4.85621 8.397 4.92616 8.49827L8.80325 13.6853C8.8444 13.7405 8.89736 13.7863 8.95846 13.8196C9.01956 13.853 9.08737 13.873 9.1572 13.8784C9.22703 13.8838 9.29723 13.8743 9.36297 13.8508C9.4287 13.8272 9.4884 13.7901 9.53796 13.7419L12.0668 11.2804L15.4418 15.2943H12.5873C12.4588 15.2943 12.3355 15.3439 12.2446 15.4324C12.1537 15.5208 12.1027 15.6407 12.1027 15.7658Z",
        fill: "#F18169"
      })
    ], -1)
  ])))
}
export default { render: render }